module.exports = __webpack_public_path__ + "static/media/logo_regiao_coimbra.a177461a.svg";